<template>
  <div class="newsletter-bar">
    <div class="title-container">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polygon fill="white" points="0,100 100,0 100,100" />
      </svg>
      <h3>Restez informés</h3>
      <p>Abonnez-vous à notre newsletter</p>
    </div>
    <form class="newsletter-form">
      <input type="text" id="name" name="name" placeholder="Votre nom" />
      <input type="email" id="email" name="email" placeholder="Votre adresse email" />
      <input type="submit" class="cg-btn cg-btn-primary" value="Je m'abonne" />
    </form>
  </div>
</template>

<script>
export default {
  name: 'NewsletterBar'
}
</script>

<style lang="scss">
.newsletter-bar {
  max-width: var(--max-width);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background: white;
  border-radius: 10px;
  padding: 0 32px 0 0;
  box-shadow: 2px 21px 20px -9px rgba(0, 0, 0, 0.19);

  .title-container {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background: black;
    color: white;
    padding: 13px 40px 13px 32px;
    border-radius: 10px 0 0 10px;

    h3 {
      margin: 0;
      font-weight: normal;

    }

    p {
      font-size: var(--font-size-small);
      font-weight: 500;
    }
  }

  .newsletter-form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  input {
    height: 46px;
    width: 240px;
    border: none;
    border-bottom: solid 1px #ddd;
    margin: 4px 6px 4px 16px;

    &:focus {
      border-color: var(--color-primary);
    }
    &:focus-visible {
      outline: 0;
    }
  }

  svg {
    position: absolute;
    right: 0;
    width: 20px;
    height: 101%;
    /* set height to pixels if you want angle to change with screen width */
  }
}
</style>